<template>
  <van-popup 
    v-model:show="showStoreDialog" 
    position="bottom" 
    :style="{ height: '100%' }"
    close-icon-position="top-right"
    @close="handleClose"
  >
    <div class="store-dialog">

      <!-- StoreCom 内容 -->
      <div class="store-dialog-content">
        <StoreCom :handleClose="handleClose" />
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useStoreDialog } from '@/composables/useStoreDialog'
import StoreCom from '@/views/message/Component/StoreCom.vue'

const { showStoreDialog, storeDialogReason, closeStoreDialog } = useStoreDialog()

const handleClose = () => {
  closeStoreDialog()
}

window.addEventListener('paymentResult', function (event: any) {
  const result = typeof event.detail === 'string' ? JSON.parse(event.detail) : event.detail
  if (result) {
    if (result.status === "success") {
      closeStoreDialog()
    }
  }
});
</script>

<style lang="scss" scoped>
.store-dialog {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--color-background);
}

.store-dialog-header {
  padding: 20px 20px 10px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.store-dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 8px 0;
}

.store-dialog-subtitle {
  font-size: 14px;
  color: #ff6b6b;
  margin: 0;
}

.store-dialog-content {
  flex: 1;
  overflow: hidden;
}
</style>
